import React, { useState } from 'react';
import PostTask from './PostTasks';
import PageOne from "../../components/PageOne/PageOne";
import PageTwo from "../../components/PageTwo/PageTwo";
import PageThree from "../../components/PageThree/PageThree";
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { postTask } from '../../Redux/Task/action';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import ToasterMessage from '../ToasterMessage';
import moment from 'moment';


const PostTaskMain = () => {

    const [toaster, setToaster] = useState("");
    const [page, setPage] = useState("pageone");
    const [isloader, setIsloader] = useState(false);
    const { id } = useParams()
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const file = e.target.files
        if (file.size > 2000000) {
            alert("Please upload file less than 2MB. Thanks!!");

        } else {

        }

        formik.setValues({
            ...formik.values,
            related_file: e.target.files
        })
    }
    const handleDateChange = (e) => {

        formik.setValues({
            ...formik.values,
            date: e
        })
    }
    const formik = useFormik({
        initialValues: {
            title: "",
            description: "",
            attachment: "",
            remote: "",
            location: "",
            budget: "",
            date: "",
            time_slot: "",

        },
        validationSchema: Yup.object().shape({
            title: Yup.string()
                .required('Required'),
            description: Yup.string()
                .required('Required'),
            // attachment: Yup.string()
            //     .required('Required'),
            // remote: Yup.string()
            //     .required('Required'),
            // location: Yup.string()
            //     .required('Required'),
            budget: Yup.string()
                .required('Required'),
            date: Yup.string()
                .required('Required'),
            time_slot: Yup.string()
                .required('Required'),

        }),
        onSubmit: (values) => {
            let formData = new FormData();    //formdata object
            formData.append("task_id", id);
            formData.append("title", values.title);
            formData.append("date_choice", moment(values.date).format("YYYY-MM-DD"));
            formData.append("time_slot", values.time_slot);
            formData.append("task_price", values.budget);
            formData.append("description", values.description);
            formData.append("location", values.location);

            if (values.related_file) {
                for (let i = 0; i < values.related_file.length; i++) {
                    formData.append('related_file', values.related_file[i]);
                }
            }
            setIsloader(true)
            // formData.append("related_file", values.related_file && values.related_file[0] ? values.related_file[0] : "");
            postTask({ formData })((response) => {
                if (response && response.status) {
                    nextPageNumber("3");
                    setIsloader(false)
                    setToaster("Post Task")
                    setTimeout(() => {
                        setToaster("")

                    }, 2000);
                }
                else {
                    setIsloader(false)

                    if (response?.response?.data?.data?.errors?.Invalid[0] != "" && response?.response?.data?.data?.errors?.Invalid[0] != undefined) {
                        setToaster("Invalid time Slot")
                        setTimeout(() => {
                            setToaster("")

                        }, 2000);
                    }
                    else {
                        setToaster("Low Balance")
                        setTimeout(() => {
                            setToaster("")

                        }, 2000);
                    }
                }



            });

        },
    });

    const nextPage = (page) => {
        setPage(page);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page]);

    const nextPageNumber = (pageNumber) => {
        switch (pageNumber) {
            case "1":
                setPage("pageone");
                break;
            case "2":
                setPage("pagetwo");
                break;
            case "3":
                setPage("pagethree");
                break;
            case "4":
                navigate('/')
                // { state: { task: true } }
                break;
            default:
                setPage("1");
        }
    };
    const onPageNumber = () => {
        if (formik.values.title && formik.values.description) {
            nextPageNumber("2")
        }
    }

    return (
        <React.Fragment>
            <Header />
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <PostTask page={page} onPageNumberClick={nextPageNumber} />
            <Form onSubmit={formik.handleSubmit}>
                {page && page == 'pageone' &&
                    <PageOne handleFileChange={handleFileChange} onButtonClick={nextPage} formik={formik} onPageNumberClick={nextPageNumber} onPageNumber={onPageNumber} />
                }
                {page && page == 'pagetwo' &&
                    <PageTwo handleDateChange={handleDateChange} onButtonClick={nextPage} formik={formik} onPageNumberClick={nextPageNumber} isloader={isloader} />
                }
                {page && page == 'pagethree' &&
                    <PageThree onButtonClick={nextPage} formik={formik} onPageNumberClick={nextPageNumber} />
                }
            </Form>

            <Footer />
        </React.Fragment>
    )
}

export default PostTaskMain;